import { Component, OnInit, OnDestroy } from '@angular/core';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthService } from "../auth.service";
import { UtilsService } from "../shared/shared.module";

import * as _ from "lodash";

declare let swal:any;

@Component({
  selector: 'cgu',
  templateUrl: './cgu.component.html',
  styleUrls: ['./cgu.component.css']
})

export class CguComponent {

  environment: any;
  errors = {};
  isLoading;

  private _subscription;

  constructor(
    private router: Router,
    private utilsService: UtilsService,
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.isLoading = false;
    this._subscription = authService.loadingChange.subscribe((value) => {
      this.isLoading = value;
    });
  }

  ngOnInit() {
    this.environment = environment;
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.utilsService.scrollTop();
    });
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  valueChange(field) {
    this.errors = {};
  }

}



// WEBPACK FOOTER //
// ./src/app/cgu/cgu.component.ts